import React, { FC, useState } from 'react';
import { DayPicker } from 'react-day-picker';
import classNames from 'classnames';
import { getYear } from 'date-fns';
import nb from "date-fns/locale/nb";

interface CalendarProps {
  onDayPick: (date: Date | null) => void;
  selectedDate?: Date;
  className?: string;
}

export const Calendar: FC<CalendarProps> = (props) => {
  const { onDayPick, selectedDate, className } = props;
  const [date, setDate] = useState<Date>(selectedDate ?? new Date());
  const currentYear = getYear(new Date());

  const onDateChange = (date: Date | undefined) => {
    if (date) {
      onDayPick(date);
      setDate(date);
    }
  }

  return (
    <DayPicker
      mode="single"
      selected={date}
      today={date}
      onSelect={onDateChange}
      captionLayout="dropdown"
      className={classNames("insuranceCalendar", className)}
      locale={nb}
      weekStartsOn={1}
      classNames={{
        caption_label: "insuranceCalendar__hidden",
        caption_dropdowns: "insuranceCalendar__dropdowns",
        dropdown: "insuranceCalendar__dropdown",
        table: "insuranceCalendar__table",
        head_row: "insuranceCalendar__header",
        head_cell: "insuranceCalendar__headCell",
        cell: "insuranceCalendar__cell",
        day: "insuranceCalendar__day",
        day_outside: "insuranceCalendar__day--outside",
        day_selected: "insuranceCalendar__day--selected",
        vhidden: "insuranceCalendar__hidden",
        button: "insuranceCalendar__button"
      }}
      fromYear={currentYear}
      toYear={currentYear + 2}
      showOutsideDays
    />
  );

};
